// extracted by mini-css-extract-plugin
export default {"WeatherStats":"WeatherStats_WeatherStats__dXLDs"};